// Utilidades para cantidades de producto con decimales.
// El XSD de Hacienda v4.4 define <Cantidad> como xs:decimal con fractionDigits=3,
// por lo que toda cantidad debe redondearse a CANT_DECIMALS antes de persistir o enviar.

export const CANT_DECIMALS = 3;

export const CANT_EPSILON = 1e-9;

const CANT_FACTOR = Math.pow(10, CANT_DECIMALS);

export const roundCant = (value: number): number => {
    return Math.round((Number(value) + Number.EPSILON) * CANT_FACTOR) / CANT_FACTOR;
};

export const formatCant = (value: number | null | undefined): string => {
    return roundCant(Number(value || 0)).toString();
};
